import { useEffect } from "react";
import { ErrorType, sidebarContent, sideBarContentForAdmin } from "../../common/constants";
import Navbar from "../../components/Navbar/Navbar";
import Sidebar from "../../components/Sidebar/Sidebar";
import AdminContainerStyles from "./AdminContainer.module.scss";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { fetchAvailableRoles } from "../../store/thunks/userInfo.thunk";
import Error from "../../components/Error/Error";
import Loader from "../../components/Loader/Loader";

const AdminContainer = ({ children }: any) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const func = async () => {
      await dispatch(fetchAvailableRoles());
    };

    func();
  }, []);

  const { profileData } = useAppSelector(
    (store) => store?.rootReducer?.userInfoReducer
  );
  const isPowerUser = profileData?.data?.isPowerUser;

  return (
    <div className={AdminContainerStyles.containerWrapper}>
      <Sidebar sidebarContent={sidebarContent} />
      <div className={AdminContainerStyles.content}>
        {/* <Navbar /> */}

        <div className={AdminContainerStyles.children}>
          {!profileData?.data ? (
            <Loader />
          ) : isPowerUser ? (
            children
          ) : (
            <Error type={ErrorType.ACCESS_DENIED} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminContainer;
